import styled from 'styled-components';

const Container = styled.div((props) => {
  return `
    display: grid;
    position: relative;
    width: 100%;
    grid-template-columns: 1fr repeat(${props.count - 2}, 2fr) 1fr;
  `;
});

const Step = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    text-align: center;
    color: ${color.grayscale[200]};
    font-size: ${type.size.tiny};
    margin-bottom: 9px;
    

    &:first-child {
      text-align: left;
    }

    &:last-child {
      text-align: right;
    }
  `;
});

const RangeSteps = ({ className, steps }) => {
  return (
    <Container count={steps.length} className={className}>
      {steps.map((step) => {
        return <Step key={step}>{step}</Step>;
      })}
    </Container>
  );
};

export default RangeSteps;
